import Frames from "@fae/source/engine/animating/Frames.js"

export default {
    "frames": Frames.run({
        "tweentime": 80,
        "images": [
            require("./fireanim-torch2-flame1-0000.png"),
            require("./fireanim-torch2-flame1-0001.png"),
            require("./fireanim-torch2-flame1-0002.png"),
            require("./fireanim-torch2-flame1-0003.png"),
            require("./fireanim-torch2-flame1-0004.png"),
            require("./fireanim-torch2-flame1-0005.png"),
            require("./fireanim-torch2-flame1-0006.png"),
            require("./fireanim-torch2-flame1-0007.png"),
        ]
    })
}
